/* tslint:disable */
/* eslint-disable */
/**
 * FancyAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const GetCourseEnabledDashboardModesR200ResponseInnerPracticeModesEnum = {
    NumberFacts: 'number_facts',
    NumberBasics: 'number_basics',
    AdaptiveMath: 'adaptive_math',
    FactPractice: 'fact_practice',
    Decodables: 'decodables',
    SightWords: 'sight_words',
    WordStudy: 'word_study',
    Library: 'library',
    SkillsPractice: 'skills_practice',
    FocusSkillsRemediation: 'focus_skills_remediation',
    ElaFocusSkills: 'ela_focus_skills',
    HsCourses: 'hs_courses'
};
/**
 * Check if a given object implements the GetCourseEnabledDashboardModesR200ResponseInner interface.
 */
export function instanceOfGetCourseEnabledDashboardModesR200ResponseInner(value) {
    if (!('courseMembershipId' in value) || value['courseMembershipId'] === undefined)
        return false;
    if (!('practiceModes' in value) || value['practiceModes'] === undefined)
        return false;
    return true;
}
export function GetCourseEnabledDashboardModesR200ResponseInnerFromJSON(json) {
    return GetCourseEnabledDashboardModesR200ResponseInnerFromJSONTyped(json, false);
}
export function GetCourseEnabledDashboardModesR200ResponseInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'courseMembershipId': json['courseMembershipId'],
        'practiceModes': json['practiceModes'],
    };
}
export function GetCourseEnabledDashboardModesR200ResponseInnerToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'courseMembershipId': value['courseMembershipId'],
        'practiceModes': value['practiceModes'],
    };
}
